import styled from 'styled-components';

export const StyledHeader = styled.div`
  padding: 24px;
  border-bottom: .5px solid #ffffff72;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;

  .title {
    font-family: 'Swiss721 Blk BT', sans-serif;
    font-weight: bolder;
    text-transform: uppercase;
  }

  .menu {
    
  }
`;